import { CommonModule } from '@angular/common';
import { Component, ContentChild, EventEmitter, Input, OnChanges, Output, TemplateRef } from '@angular/core';
import { BrIconComponent } from '../../shared/ui/icon/icon.component';

/** Display contract only. Task execution and persistence are not implemented here. */
export interface ConversationTaskView {
  id: string;
  title: string;
  agentName: string;
  status: 'queued' | 'running' | 'completed' | 'failed' | 'canceled';
  progress: string;
  subAgents?: { name: string; activity: string }[];
  result?: string;
  /** A new completion result has arrived and has not been viewed. */
  unread?: boolean;
  error?: string;
}

@Component({
  selector: 'app-conversation-tasks',
  standalone: true,
  imports: [CommonModule, BrIconComponent],
  templateUrl: './conversation-tasks.component.html',
  styleUrls: ['./conversation-tasks.component.css', './conversation-scrollbar.css'],
})
export class ConversationTasksComponent implements OnChanges {
  @Input() tasks: readonly ConversationTaskView[] = [];
  @Input() preview = false;
  @Output() returnToConversation = new EventEmitter<void>();
  @Output() taskViewed = new EventEmitter<string>();
  @Output() taskAction = new EventEmitter<{ id: string; action: 'cancel' | 'retry' }>();

  @ContentChild(TemplateRef) customDetail?: TemplateRef<{ $implicit: ConversationTaskView }>;

  selectedId: string | null = null;
  inProgress: readonly ConversationTaskView[] = [];
  recent: readonly ConversationTaskView[] = [];
  readonly statusLabels: Record<ConversationTaskView['status'], string> = {
    queued: 'Queued', running: 'Running', completed: 'Completed', failed: 'Failed', canceled: 'Canceled',
  };

  get selectedTask(): ConversationTaskView | undefined {
    return this.tasks.find(task => task.id === this.selectedId);
  }

  ngOnChanges(): void {
    this.inProgress = this.tasks.filter(task => task.status === 'queued' || task.status === 'running');
    this.recent = this.tasks.filter(task => task.status !== 'queued' && task.status !== 'running');
    if (!this.selectedTask) this.selectedId = null;
  }

  openTask(task: ConversationTaskView): void {
    this.selectedId = task.id;
    this.taskViewed.emit(task.id);
  }

  trackTask(_index: number, task: ConversationTaskView): string { return task.id; }
}
